import { linkedSignal } from '@angular/core';
import type { OnyxChip } from '@onyx/angular';

export const linkedChipSignal = <T>(
  chips: () => OnyxChip<T>[],
  defaultValue?: T,
) =>
  linkedSignal<OnyxChip<T>[], [T]>({
    source: chips,
    computation: (chips, previous) => [
      chips.find(
        ({ value }) => value === (previous?.value?.at(0) ?? defaultValue),
      )?.value ?? chips[0].value,
    ],
  });
